/**
 * Helpers for resolving Prismic-authored meta tags against the values a page
 * hardcodes. Kept separate from `@components/seo` so the "is this actually
 * filled in?" rule lives in one testable place.
 */

// The Meta Info fields are StructuredText, so depending on how a page queries
// them a value arrives as a `{ text }` object, a raw block array, or (if the
// field was never added to the document) null. An empty rich text field is
// `[]` rather than null, and a cleared one can still hold a block with an
// empty string — so unwrap first, then decide.
export const metaText = value => {
  if (value === null || value === undefined) return null;

  let text = null;
  if (typeof value === 'string') {
    text = value;
  } else if (Array.isArray(value)) {
    text = value.map(block => block?.text || '').join(' ');
  } else if (typeof value === 'object') {
    text = value.text || '';
  }

  if (typeof text !== 'string') return null;
  const trimmed = text.trim();
  return trimmed === '' ? null : trimmed;
};
